import * as React from 'react';
import { ButtonStyle } from '../components/Button';
import Loader from '../components/Loader';
import Page from '../components/Page';
import CompanyAppPreview from '../components/CompanyAppPreview';
import { ActionBar, ActionBarStyle } from '../components/ActionBar';
import BasicDetails from './edit-company/BasicDetails';
import CompanyLocation from './edit-company/CompanyLocation';
import CompanyAppearance from './edit-company/CompanyAppearance';
import { ProfileContext } from '../profile';
import { useRequestAsync, getHeaders } from '../api/client';
import Flash, { ErrorFlash } from '../components/Flash';
import { Link, Redirect } from 'react-router-dom';

type CompanyParams = {
  name: string;
  description_text: string;
  image_url: string;
};

export default () => {
  const context = React.useContext(ProfileContext);
  const { profile } = context;

  if (!profile.company) {
    return <Redirect to="/company/new" />;
  }

  const [company, setCompany] = React.useState(profile.company);

  const [state, submit] = useRequestAsync((data: CompanyParams) => ({
    url: `/companies/${profile.company_id}`,
    method: 'PUT',
    body: JSON.stringify(data),
    headers: getHeaders(context),
  }));

  React.useEffect(() => {
    if (!state.data) {
      return;
    }

    context.set({
      ...profile,
      company: state.data,
    });
  }, [state]);

  if (state.loading) {
    return <Loader />;
  }

  return (
    <Page
      title="Edit Company"
      subtitle="Customize the look and feel of your coffee brand"
    >
      {state.error && <ErrorFlash error={state.error} />}
      {state.complete && <Flash text="Profile has been saved" />}
      <div className="flex justify-center ml-auto mr-auto">
        <Link
          to="/dashboard"
          className="f5 link br-pill bg-near-white hover-bg-black-10 ph4 pv3 mh2 b black"
        >
          ← Back to Dashboard
        </Link>
      </div>
      <BasicDetails company={company} onChange={setCompany} />
      <CompanyLocation company={company} onChange={setCompany} />
      <CompanyAppearance company={company} onChange={setCompany}>
        <h4 className="f6 db mb2 ttu tc fw3 white-80">IN-APP PREVIEW</h4>
        <CompanyAppPreview company={company} />
      </CompanyAppearance>
      <ActionBar
        className={ActionBarStyle.alignCenter}
        actions={[
          {
            className: ButtonStyle.Confirm,
            label: 'Save',
            handler: () => submit(company),
          },
        ]}
      />
    </Page>
  );
};
